import React from 'react';

interface AreaInputProps {
  value: number;
  onChange: (area: number) => void;
}

const AreaInput: React.FC<AreaInputProps> = ({ value, onChange }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-neutral-700 mb-1">
        Surface du bien ou des pièces à rénover <span className="text-red-500">*</span>
      </label>
      <div className="flex items-center space-x-2">
        <input
          type="number"
          value={value || ''}
          onChange={(e) => onChange(parseInt(e.target.value) || 0)}
          min="0"
          step="0.5"
          className="input flex-1"
          placeholder="Surface en m²"
          required
        />
        <span className="text-neutral-500">m²</span>
      </div>
      <p className="mt-2 text-sm text-neutral-500">
        Indiquez la surface totale concernée par les travaux
      </p>
    </div>
  );
};

export default AreaInput;